import { PatientAnamnesisStruct } from "../../structs/sync-measurer/patient-anamnesis.struct";

export class AnamnesisRequest extends PatientAnamnesisStruct{
    public idSyncMeasurer: number | null = null;
}